import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetKontraktsradJusteringCommand extends BasicCommand<SetKontraktsradJusteringCommand> {
    get primaryKey(): IPrimaryKey<SetKontraktsradJusteringCommand> {
        return {
            arbetsorderContractLineId: this.arbetsorderContractLineId
        };
    }
    arbetsorderContractLineId: number;
    affarsledJusterat: string;
    kollektivJusterat: string;
    matmetodAJusterat: string;
    matmetodBJusterat: string;
    matmetodCJusterat: string;
    matmetodDJusterat: string;
    transportalternativ9Justerat: boolean;
    voStatusRadJusterat: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetKontraktsradJusteringCommand";
    constructor(init: (instance: SetKontraktsradJusteringCommand) => void) {
        super(SetKontraktsradJusteringCommand.$type, SetKontraktsradJusteringCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
